module.exports = __webpack_public_path__ + "static/Aproved-6ea1bd79e0afa77cb34340c593d3bd7c.png";